import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Pricing } from './pages/Pricing';
import { AdditionalCosts } from './pages/AdditionalCosts';
import { Contact } from './pages/Contact';
import { Industries } from './pages/Industries';
import { Crm } from './pages/Crm';
import { Websites } from './pages/Websites';
import { Gallery } from './pages/Gallery';
import { useHashRoute, type Route } from './hooks/useHashRoute';
import { trackPageView } from './utils/tracking';
const pageTitles: Record<Route, string> = {
  home: 'Ad ROI Marketing | Marketing & Conversions',
  pricing: 'Pricing & Plans | Ad ROI Marketing',
  additionalCosts: 'Additional Costs & Usage Rates | Ad ROI Marketing',
  contact: 'Contact Us | Ad ROI Marketing',
  industries: 'Industries We Serve | Ad ROI Marketing',
  crm: '1Dash.Pro CRM | Ad ROI Marketing',
  websites: 'Living Websites: Websites That Run Themselves | Ad ROI Marketing',
  gallery: 'Our Work: Website Gallery | Ad ROI Marketing'
};

// Per-page search descriptions. Written into the description and social tags on every page change.
const pageDescriptions: Record<Route, string> = {
  home: 'Ad ROI Marketing in Las Vegas: websites, marketing and the 1Dash.Pro CRM, Powered by HighLevel.',
  pricing: 'Simple monthly plans from $315: your website, phone system, reviews and the 1Dash.Pro CRM, Powered by HighLevel. See what each plan includes.',
  additionalCosts: 'Usage rates and add-ons for Ad ROI plans: calls, texts, email, extra websites and more. No surprises.',
  contact: 'Talk to a real person in Las Vegas about your website and marketing. Call (702) 213-4801 or send us a message.',
  industries: 'Websites, marketing and CRM built for home services, restaurants, med spas, real estate and more.',
  crm: 'The 1Dash.Pro CRM, Powered by HighLevel: contacts, calendar, texting, email, reviews and payments in one place.',
  websites: 'Change your website in minutes by phone, text, email, Slack or online. Built in 3 days, checked live before we say done.',
  gallery: 'Real websites and landing pages we built for real businesses. Every one started as a 3-day build.'
};
function setMeta(attr: 'name' | 'property', key: string, value: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}
export function App() {
  const route = useHashRoute();
  const firstView = useRef(true);
  useEffect(() => {
    if (document.getElementById('adroi-chat-widget')) return;
    const script = document.createElement('script');
    script.id = 'adroi-chat-widget';
    script.src = 'https://widgets.leadconnectorhq.com/loader.js';
    script.async = true;
    script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
    script.setAttribute('data-widget-id', '6694c84d748b68476dace44d');
    document.body.appendChild(script);
  }, []);
  useLayoutEffect(() => {
    document.title = pageTitles[route];
    setMeta('name', 'description', pageDescriptions[route]);
    setMeta('property', 'og:title', pageTitles[route]);
    setMeta('property', 'og:description', pageDescriptions[route]);
    // Initial load is tracked here; later hash changes are tracked by the global listener.
    if (firstView.current) {
      firstView.current = false;
      trackPageView();
    }
  }, [route]);
  return <div className="min-h-screen w-full bg-white font-sans text-gray-900 selection:bg-red-200 selection:text-red-900" data-id="element-0" data-mp="1i5nldi2sbpnb">
      <AnnouncementBar data-id="element-1" data-mp="6onr4gwvn0qn" />
      <Navbar route={route} data-id="element-2" data-mp="6o5w1nlyaskb" />
      <main data-id="element-3" data-mp="6mul93u38kjp">
        {route === 'pricing' && <Pricing data-id="element-4" data-mp="aq0ywwjj5e07" />}
        {route === 'additionalCosts' && <AdditionalCosts data-id="element-5" data-mp="aqslxiz2a3ev" />}
        {route === 'contact' && <Contact data-id="element-6" data-mp="qwvpk8lpwd3q" />}
        {route === 'industries' && <Industries data-id="element-7" data-mp="qyqb9p4tc98v" />}
        {route === 'crm' && <Crm data-id="element-8" data-mp="m6fdartmuxiy" />}
        {route === 'websites' && <Websites data-id="element-9" data-mp="m5dxka1o9muw" />}
        {route === 'gallery' && <Gallery data-id="element-10" data-mp="m4m3x4rmxz79" />}
        {route === 'home' && <Home data-id="element-11" data-mp="h6kmeo9uy7xw" />}
      </main>
      <Footer data-id="element-12" data-mp="h7vmoe43gxk9" />
    </div>;
}